import { Series, UserCollection } from 'state/types'
import { DMD_PINATA_BASE_URL, PINATA_BASE_URL } from 'config'
import { getAddress } from 'utils/addressHelpers'

export const fetchUserCollectionsDMD = (serieses: Series[]): UserCollection[] => {
  const userCollectionsDMD = []
  serieses.forEach((series) => {
    const index = userCollectionsDMD.findIndex(
      (userCollection: UserCollection) => userCollection.address === getAddress(series.address),
    )
    if (index >= 0) {
      userCollectionsDMD[index] = {
        ...userCollectionsDMD[index],
        nfts: userCollectionsDMD[index].nfts.concat(series.userData?.nfts.filter((nft) => nft.isStaked)),
      }
    } else {
      userCollectionsDMD.push({
        key: series.key,
        name: series.collectionName || series.name,
        image: series.image,
        animation: series.animation,
        address: getAddress(series.address),
        nfts: series.userData?.nfts,
      })
    }
  })

  return userCollectionsDMD.filter((userCollection) => userCollection.nfts?.length)
}

export const fetchNftsFromMoralis = async (account) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API}/nft/${account}`)
    const result = await response.json()
    if (result.status === 'success') {
      return result.data
    }
    return []
  } catch (error) {
    console.error(error)
    return []
  }
}

export const fetchUserCollectionsWith = async (userCollectionsDMD: UserCollection[], nftsFromMoralis) => {
  const userCollectionsMoralis = nftsFromMoralis
    .filter(
      (nft) => !userCollectionsDMD.find((userCollection) => userCollection.address.toLowerCase() === nft.token_address),
    )
    .reduce((userCollectionsFromMoralis: UserCollection[], nft) => {
      const nftMetadata = JSON.parse(nft.metadata)
      let image = nftMetadata?.image
      if (image) {
        image = image?.replace('https://gateway.pinata.cloud/ipfs', PINATA_BASE_URL)
        image = image?.replace(DMD_PINATA_BASE_URL, PINATA_BASE_URL)
        if (image?.startsWith('ipfs')) {
          image = `${PINATA_BASE_URL}/${image.split('://')[1]}`
        }
      } else {
        image = 'dmd.png'
      }
      const dNft = {
        nid: Number(nft.token_id),
        name: nftMetadata?.name,
        description: nftMetadata?.description,
        image,
        animationUrl: nftMetadata?.animation_url,
        attributes: nftMetadata?.attributes,
      }

      let ret
      if (userCollectionsFromMoralis.find((userCollection) => userCollection.address === nft.token_address)) {
        ret = userCollectionsFromMoralis.map((userCollection) => {
          if (userCollection.address !== nft.token_address) {
            return userCollection
          }
          const nfts = userCollection.nfts
          nfts.push(dNft)
          return { ...userCollection, nfts }
        })
      } else {
        userCollectionsFromMoralis.push({
          key: nft.name.toLowerCase(),
          name: nft.name,
          image,
          animation: nftMetadata?.animation_url,
          address: nft.token_address,
          nfts: [dNft],
        })
        ret = userCollectionsFromMoralis
      }
      return ret
    }, [])

  return userCollectionsDMD.concat(userCollectionsMoralis)
}
